/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { Component } from 'react';
import FreshbooksConnect from './freshbooks/FreshbooksConnect';
import QuickbooksConnect from './quickbooks/QuickbooksConnect';
import AccountActions from '../../support/AccountActions';
import { postJSON } from '../../support/Fetch';
import { showError } from '../App/AppAlert';
import { Link } from '../Navigation';
import ensureObject from '../../support/shared/ensureObject';

import {
  DEFAULT_INVOICE_PROVIDER,
  INVOICE_PROVIDERS,
} from '../../support/shared/constants/Constants';

import { Account } from '../../types/shared/Account';

type Props = {
  account: Account;
  children?: React.ReactNode;
  invoiceProvider?: 'freshbooks' | 'quickbooks';
  showBillingLink?: boolean;
  vendorId?: string;
};

class InvoiceConnect extends Component<Props> {
  render() {
    let {
      account,
      children,
      invoiceProvider,
      showBillingLink,
      vendorId,
    } = this.props;
    let { settings } = account;

    if (showBillingLink && vendorId) {
      return (
        <Link to={['/billing/vendors/:id', { id: vendorId }]}>
          {t('Vendor Billing/Invoice')}
        </Link>
      );
    }

    let savedInvoiceProvider =
      (settings && settings.invoice_provider) || DEFAULT_INVOICE_PROVIDER;

    let provider = invoiceProvider ? invoiceProvider : savedInvoiceProvider;

    switch (provider) {
      case INVOICE_PROVIDERS.freshbooks:
        return (
          <FreshbooksConnect
            account={account}
            onInvoiceProviderConnected={() =>
              this._onInvoiceProviderConnected('freshbooks')
            }
          >
            {children}
          </FreshbooksConnect>
        );
      case INVOICE_PROVIDERS.quickbooks:
        return (
          <QuickbooksConnect
            account={account}
            onInvoiceProviderConnected={() =>
              this._onInvoiceProviderConnected('quickbooks')
            }
          >
            {children}
          </QuickbooksConnect>
        );
      default:
        return null;
    }
  }

  _onInvoiceProviderConnected = (invoiceProvider: string) => {
    let { account } = this.props;

    let updates = {
      invoice_provider: invoiceProvider,
    };

    if (account) {
      let accountID = account.id;
      let postData = {
        account: {
          settings: updates,
        },
      };
      postJSON(
        `/api/accounts/${accountID}/settings`,
        postData,
        (error, data) => {
          if (error) {
            console.error(error); // eslint-disable-line no-console
            let errorObject = ensureObject(error);
            let errorMessage = errorObject
              ? String(errorObject.message)
              : String(error);
            showError(`Unable to complete request: ${errorMessage}`);
            return;
          }
          if (data.success) {
            AccountActions.updateSettings(updates);
          }
        },
      );
    }
  };
}

export default InvoiceConnect;
